module.exports = __webpack_public_path__ + "img/20190808170241283.ab5def44.png";